module.exports = __webpack_public_path__ + "static/9-projects-transforming-the-campus-1af2d9bc000abba15c7f7626249d2943.jpg";